<template>
	<div>
		<el-image fit="contain" class="aggregationbox_logo mt-49 ml-71" :src="require('@/assets/logo3.png')" />
		<div class="aggregationbox_cp">
			<!-- <el-image fit="contain" class="" :src="require('@/assets/pc/mall/mall1.png')" alt="" /> -->
			<!-- <el-carousel @setActiveItem="qihuanan" :autoplay='false' ref="miaoshugao"  height="7.8rem"  class="aggregationbox_cp2 mt-163"  @change="tuqie">
				 <el-carousel-item v-for="(item,i) in shu.images" :key="item">
					 <div style="width: 100%;display: flex;justify-content: center;flex-wrap: wrap;">
						<el-image fit="contain" class="aggregationbox_cptu " :src="require('@/assets/pc/cp1.png')" alt="" />
						<div class="w100">
							<div class="w100 mt-90 f-80 montserBold" style="color: #fff;text-align: center;">{{shu.title}}</div>
							<div class="tit-30 montserLight miaoshugaobox" ref="miaoshugaoboxRef" style="color: #fff;text-align: center;margin:0 .7rem;" v-if="shu && shu.attributes ">{{combinedStr}}</div>
						</div>
					 </div>
				</el-carousel-item>
			</el-carousel> -->
			<div class="swiper-container swiper-container1">
				<div class="swiper-wrapper">
					<div v-for="(product, index) in shu.images" :key="index" class="swiper-slide videoswiperslides2">
						<div style="display: block; " class="imgBox">
							<img style="display: block;margin:1.6rem auto 0 auto ;" class=" aggregationbox_cptu"
								:src="product" />
						</div>
					</div>
				</div>
			</div>
			<div class="w100">
				<div class="w100 mt-40  montserBold" style="color: #fff;text-align: center;font-size:0.7rem;">
					<span v-if="shu && shu.item">{{shu.item.title}}</span>
				</div>
				<div class="tit-30 montserLight miaoshugaobox" ref="miaoshugaoboxRef" style="color: #fff;text-align: center;margin:0 .7rem;" v-if="shu && shu.item && shu.item.attributes ">{{combinedStr}}</div>
			</div>
			<ul class="aggregationbox_lunbo mt-40"> 
				<!-- :class="tzshu.isLike ? 'bj-E6 ys-0' : 'bj-0'" -->
				<li class=""  :class="currentIndex==i? 'aggregationbox_lunbodianactive' : 'aggregationbox_lunbodian'"    v-for="(l,i) in dianchang"></li>
			</ul>
		</div>
		<div style="align-items: center;margin-bottom:4rem;" class="w100 mt-40" v-if=" shu && shu.item">
			<div class="aggregationbox_button flex j-between " v-if="shu && shu.item && shu.item.buttons.length>0" v-for="(b,i) in shu.item.buttons" @click="tiao(b)">
				<div class="flex">
					<el-image fit="contain" class="aggregationbox_buttontu mt-32 ml-67"
						:src="b.image" />
					<div class="tit-24 ys-0 ml-24 montserRegular" style="line-height: 1.18rem;">{{b.name}}</div>
				</div>
				<div class="iconfont icon-jinru1 mr-50" style="color: rgba(255, 255, 255, .65);line-height: 1.18rem;">
				</div>
			</div>
		</div>
		<div class="aggregationbox_dibu w100">
		<!-- 	<div style="line-height: 1.2rem;" class="ml-113">
				<i class="iconfont icon-earth tit-26 ys-0 mr-5"></i>
				<i class="ys-0 tit-24">{{yuyan}}</i>
			</div> -->
			<i class="iconfont icon-earth tit-26 ys-0 mr-5" style="line-height: 1.2rem;"></i>
			<el-select @change="xuanyuyans" v-model="yuyan2" placeholder="Select Language" class="aggregationbox_dibuin">
				<el-option class="tit-24" v-for="(item,i) in yuyans" :key="i" :label="item.name" :value="i"> </el-option>
			</el-select>
		</div>
	</div>
</template>

<script>
	// import {
	// 	Yuyanlies
	// } from '@/api/resource.js';
	import {
		juhechangpinxiangqing,Aggregationsx,Yuyanlies
	} from '@/api/PointsMall.js';
	import Swiper from 'swiper'; // 注意引入的是swipe
	import 'swiper/css/swiper.min.css'
	export default {
		data() {
			return {
				goods: [],
				shu: {},
				pindex: 0,
				combinedStr: '',
				yuyan: 'EN',
				yuyan2: 'English',
				yuyans: [],
				aid: '',
				dianchang:0,
				currentIndex:0
			}
		},
		created: function() {
			this.aid = this.$route.query.id;
			if (this.aid) {
				this.sxshangpin()
				// juhechangpinxiangqing({
				// 	id: this.aid
				// }).then(s => {
				// 	this.shu = s.data
				// 	if (this.shu.images) {
				// 		this.shu.images = this.shu.images.split(',');
				// 		this.dianchang=this.shu.images.length
				// 		const values = this.shu.attributes.map(item => item.value);
				// 		this.combinedStr = values.join(' | ');
				// 		if (this.combinedStr.endsWith(' | ')) {
				// 			this.combinedStr = this.combinedStr.slice(0, -1);
				// 		}
				// 	}
				// })
				Yuyanlies({id:this.aid}).then(shu => {
					if (shu.data && shu.data.length > 0) {
						this.yuyans = shu.data.map(item => {
							return {
								...item, // 保留原对象的所有属性  
								label: item.name, // 添加 label 属性，您可以根据需要设置标签内容  
								value: item.name
							};
						});
					}
				})
			}
		},
		mounted() {
			this.getSwiper()
			//  this.$nextTick(() => {
			//    const miaoshugaobox = this.$refs.miaoshugaoboxRef;
			// console.log(miaoshugaobox)
			//    if (miaoshugaobox) {
			//      const height = miaoshugaobox.offsetHeight;
			//      console.log('miaoshugaobox的高度为：', height);
			//      // 这里可以进行其他关于高度的处理
			//    }
			//  });
		},
		methods: {
			tuqie(e) {
				this.pindex = e
			},
			tiao(e) {
				if (e.url) {
					const regex = /https?:\/\//;
					const regex2 = /http?:\/\//;
					if(regex.test(e.url)==true || regex2.test(e.url)==true){
						window.open(e.url)
					}else{
						window.open('https://community.goodwe.com'+e.url)
					}
				}
			},
			getSwiper() {
				this.swiper = new Swiper(".swiper-container1", {
					loop: true,
					autoplay: false,
					slidesPerView: 1, // 一组三个
					spaceBetween: 20, // 间隔
					// 如果需要前进后退按钮
					// navigation: {
					// 	nextEl: '.conInfoOne .swiper-button-next',
					// 	prevEl: '.conInfoOne .swiper-button-prev',
					// },
					// 窗口变化,重新init,针对F11全屏和放大缩小,必须加
					observer: true,
					observeParents: true,
					on: {
					  slideChange: () => {
						// 获取当前活动幻灯片的索引
						this.currentIndex = this.swiper.activeIndex;
						// 如果是循环模式，需要调整索引以匹配实际数组下标
						if (this.swiper.params.loop) {
						  this.currentIndex = this.swiper.realIndex;
						}
					  }
					}
				})
			},
			xuanyuyans(e) {
				this.yuyan=this.yuyans[e].code
				this.yuyan2=this.yuyans[e].name
				this.sxshangpin()
			},
			sxshangpin(){
				juhechangpinxiangqing({
					id: this.aid,
					language:this.yuyan2
				}).then(s => {
					this.shu = s.data
					if (this.shu.images) {
						this.shu.images = this.shu.images.split(',');
						this.dianchang=this.shu.images.length
						if(this.shu.item && this.shu.item.attributes){
							const values = this.shu.item.attributes.map(item => item.value);
							this.combinedStr = values.join(' | ');
							if (this.combinedStr.endsWith(' | ')) {
								this.combinedStr = this.combinedStr.slice(0, -1);
							}
						}
					}
				})
				// Aggregationsx({title:this.shu.title,language:this.yuyan}).then(s=>{
				// 	if(s.code==200){
				// 		this.shu=s.data
				// 		if (this.shu.images) {
				// 			this.shu.images = this.shu.images.split(',');
				// 			this.dianchang=this.shu.images.length
				// 			const values = this.shu.attributes.map(item => item.value);
				// 			this.combinedStr = values.join(' | ');
				// 			if (this.combinedStr.endsWith(' | ')) {
				// 				this.combinedStr = this.combinedStr.slice(0, -1);
				// 			}
				// 		}
				// 	}
				// })
			},
			qihuanan(e) {
			}
		}
	}
</script>

<style lang="scss">
	body {
		width: 100%;
		// height: 100vh;
		background: url('../../../assets/pc/pbg.png') no-repeat;
		background-size: cover;

		.aggregationbox_logo {
			width: 2.5rem;
			height: .38rem;
		}
	}
	.swiper-container .swiper-slide .imgBox {
		overflow: hidden;
	}
	.swiper-container .swiper-slide .imgBox img {
		transition: .5s;
	}
	.swiper-container .swiper-slide:hover .imgBox img {
		transform: scale(1.1);
	}
	.aggregationbox_lunbo{
		
	}
	.aggregationbox_lunbo{
		width: 100%;
		display: flex;
		justify-content: center;
	}
	.aggregationbox_lunbodian {
		width: 9px;
		height: 9px;
		border-radius: 50%;
		margin-left: .1rem;
		background-color: rgba(0, 0, 0, 0);
		/* 设置未激活的指示点颜色完全透明 */
		border: 1px solid #e60012;
		/* 未激活的指示点颜色 */
		box-sizing: border-box;
		margin: .12rem .04rem;
	}

	.aggregationbox_lunbodianactive {
		background-color: #e60012 !important;
		width: 9px;
		height: 9px;
		border-radius: 50%;
		border: none !important;
		padding: 0;
		margin: .12rem .04rem;
	}

	.aggregationbox_cptu {
		width: 4.63rem;
		height: 3.61rem;
	}

	.aggregationbox_button {
		width: 88%;
		margin: 0 auto;
		height: 1.18rem;
		margin-bottom: .32rem;
		// opacity: 0.45;
		background: linear-gradient(-6deg, rgba(159, 159, 159, .4) 0%, rgba(59, 59, 59, .4) 100%);
		border: 2px solid #b5b5b5;
		border-radius: 61px;
		white-space:nowrap;
		.aggregationbox_buttontu {
			width: .66rem;
			height: .66rem;
		}
	}

	.aggregationbox_dibu {
		height: 1.2rem;
		background: #404040;
		position: fixed;
		display: flex;
		justify-content: end;
		bottom: 0;
		left: 0;

		.aggregationbox_dibuin {
			width: 25%;
		}

		.aggregationbox_dibuin .el-input .el-input__inner {
			padding-left:0 !important;
			background-color: rgba(0, 0, 0, 0);
			border: none;
			height: 1.2rem;
			line-height: 1.2rem;
			text-align: right;
			color:#fff;
			font-size: .32rem;
		}
	}
</style>